// import {
//   CloudOneSVG,
//   CloudTwoSVG,
//   CloudThreeSVG,
// } from '../../components/common/svgs/clouds'
import HomeMain from '../../components/home'

const Home = () => {
  return (
    <>
      <HomeMain />
    </>
  )
}

export default Home
